
import AddUserForm from 'components/addUserForm/AddUserForm';
import '../../styles/fonts/fonts.css';

const AddAdminPage = () => {

  return (
    <AddUserForm
      roleName="Firm Admin"
      returnEndpoint='firm-admin'
    />
  );
};

export default AddAdminPage;